import React, {useState, useEffect} from "react";
import "./CardPreview.css";
import { extractCardData } from "../../utils/cardData";
import { convertMana } from "../../utils/manaConverter";

const CardPreview = ({ card, position }) => {
  const { manaCost, typeLine, oracleText } = extractCardData(card);

  // set state for mana conversion
  const [manaSymbols, setManaSymbols] = useState([""]);
  // convert mana cost to symbols
  useEffect(() => {
    convertMana(manaCost, setManaSymbols);
  }, [manaCost]);

  return (
<div className="card-preview" style={position}>
  <div className="mana-wrapper">{manaSymbols}</div>

  <p className="type-line">{typeLine}</p>
  <p className="rules-text">{oracleText}</p>
</div>


  );
};

export default CardPreview;
